// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';

/** 计费系统签名三元组，由后端签发，五分钟内有效，需现取现用 */
export interface BillingTokenInfo {
    /** 计费系统租户标识，作为 billing-tenant-sdk 的 appId 使用 */
    billingId: string;
    /** 计费集群区域，用于确定计费系统域名 */
    region: string;
    sign: string;
    timestamp: number;
}

export interface BaseResponseBillingTokenInfo {
    data?: BillingTokenInfo;
}

/**
 * 获取计费系统签名
 *
 * @export
 * @tags 计费接口
 * @link [GET] /companys/billing/token
 */
export function getCompanysBillingToken(
    options?: ApiOptions<never, never>
): Promise<BaseResponseBillingTokenInfo> {
    return request<never, never, never>('/companys/billing/token', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getCompanysBillingToken',
    });
}

export const meta = [{ tags: ['计费接口'], path: '/companys/billing/token', method: 'get' }];
